<template>
  <v-data-table
    :headers="headers"
    :items="lifeyrisgreidslur"
    :loading="loading"
    loading-text="Sæki gögn..."
    no-data-text="Engin gögn fundust"
    hide-default-footer
    :mobile-breakpoint="0"
    hover
  >
    <template #item.arMan="{ item }">
      {{ item.arMan }}
    </template>

    <template #item.greitt="{ item }">
      <div class="text-right">{{ currency(item.greitt) }}</div>
    </template>

    <template #item.greittAdrirSjodir="{ item }">
      <div class="text-right">{{ currency(item.greittAdrirSjodir) }}</div>
    </template>

    <template #item.stadgreidslaSkatta="{ item }">
      <div class="text-right">{{ currency(item.stadgreidslaSkatta) }}</div>
    </template>

    <template #item.utborgad="{ item }">
      <div class="text-right">{{ currency(item.utborgad) }}</div>
    </template>

    <template #item._actions="{ item }">
      <v-btn
        variant="text"
        icon="mdi-chevron-down"
        class="down-arrow"
        :aria-label="t('pension_more')"
        @click="$emit('open-month', item)"
      />
    </template>
  </v-data-table>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCurrency } from '@/composables/useCurrency'

const { t } = useI18n()
const { currency } = useCurrency()

defineProps<{
  lifeyrisgreidslur: any[]
  loading?: boolean
}>()

defineEmits<{
  (e: 'open-month', row: any): void
}>()

type Header = {
  title: string
  key: string
  align?: 'end' | 'start' | 'center'
  sortable: boolean
}

const headers = computed<Header[]>(() => [
  { title: t('lifeyrisTable_ar'), key: 'arMan', sortable: false },
  { title: t('lifeyrisTable_greitt'), key: 'greitt', align: 'end', sortable: false },
  { title: t('lifeyrisTable_greittAdrirSjodir'), key: 'greittAdrirSjodir', align: 'end', sortable: false },
  { title: t('lifeyrisTable_stadgreidslaSkatta'), key: 'stadgreidslaSkatta', align: 'end', sortable: false },
  { title: t('lifeyrisTable_utborgad'), key: 'utborgad', align: 'end', sortable: false },
  { title: t('pension_more'), key: '_actions', align: 'end', sortable: false },
])
</script>

<style scoped>
.down-arrow { cursor: pointer; }
</style>
